import { AuditTemplate } from '../auditTypes';
import { q } from './q';

export const MONTHLY: AuditTemplate[] = [
  {
    id: 'monthly-meds', name: 'Monthly Medication Management Audit', frequency: 'monthly',
    description: 'Full Reg 12 medicines review.',
    questions: [
      q('mm01', 'Sample 5 MAR charts: 100 percent complete, correct signatures, codes used properly, gaps actioned.', 'safe', 'Reg 12', true),
      q('mm02', 'PRN protocols specific with dose, max daily, indication, and reviewed for effectiveness.', 'safe', 'Reg 12'),
      q('mm03', 'Covert administration only with MCA best-interest decision and GP involvement, documented.', 'safe', 'Reg 12', true),
      q('mm04', 'Controlled drug register: running balance, dual signatures, errors one line and witnessed.', 'safe', 'Reg 12', true),
      q('mm05', 'Storage locked, clean, in date stock rotated; fridge 2 to 8C logged.', 'safe', 'Reg 12'),
      q('mm06', 'Discontinued and expired medicines returned to pharmacy with records.', 'safe'),
      q('mm07', 'Staff competency: observed administration and annual competency assessment on matrix.', 'wellled', 'Reg 18'),
      q('mm08', 'Errors and near misses trended monthly with actions shared in closed loop.', 'wellled', 'Reg 17'),
      q('mm09', 'Pharmacist medicine reviews happening for residents regularly.', 'effective'),
      q('mm10', 'Homely remedy and stock medicine scheme managed per policy.', 'safe'),
    ],
  },
  {
    id: 'monthly-safeguarding', name: 'Monthly Safeguarding Audit', frequency: 'monthly',
    description: 'Reg 13 safeguarding from abuse and improper treatment.',
    questions: [
      q('sg01', 'All allegations recorded; LA and CQC notified in timescale; outcomes recorded.', 'safe', 'Reg 13', true),
      q('sg02', 'Staff can name types of abuse and the whistleblowing route.', 'safe', 'Reg 13'),
      q('sg03', 'Safeguarding training current for all staff on the matrix.', 'wellled', 'Reg 18'),
      q('sg04', 'Residents know how to raise a worry; posters visible; residents say they feel safe.', 'caring', 'Reg 13'),
      q('sg05', 'Body maps used for injuries; unexplained injuries investigated and reported.', 'safe', 'Reg 13', true),
      q('sg06', 'Lessons learned from incidents shared in meetings and minuted.', 'wellled', 'Reg 17'),
      q('sg07', 'Allegations against staff managed per policy; LADO notified where required.', 'safe', 'Reg 13', true),
    ],
  },
  {
    id: 'monthly-premises', name: 'Monthly Environment and Premises Audit', frequency: 'monthly',
    description: 'Reg 15 premises and equipment inside and out.',
    questions: [
      q('pr01', 'Decor and furnishings good; homely and dementia friendly with contrast and signage.', 'responsive'),
      q('pr02', 'Lighting adequate including night; heating comfortable; hot water safe with TMVs.', 'safe', 'Reg 15'),
      q('pr03', 'Legionella logbook complete: temps, flushing, shower cleans, tank inspections in date.', 'safe', 'Reg 15', true),
      q('pr04', 'Fire doors self close; intumescent brushes fitted; drill done this month with learning logged.', 'safe', 'Reg 15'),
      q('pr05', 'Maintenance register complete: LOLER, PAT, gas, electrical, boiler, extraction all in date.', 'safe', 'Reg 15', true),
      q('pr06', 'Bedrooms personalised; residents own belongings respected.', 'caring', 'Reg 10'),
      q('pr07', 'Bathrooms have grab rails, non slip mats, call bells, clean towels.', 'safe'),
      q('pr08', 'Garden safe and actually used by residents.', 'responsive'),
      q('pr09', 'Windows, doors, locks, alarms working; visitor management effective.', 'safe'),
      q('pr10', 'Odour free throughout; ventilation adequate.', 'safe'),
    ],
  },
  {
    id: 'monthly-care-docs', name: 'Monthly Care Documentation and MCA Audit', frequency: 'monthly',
    description: 'Regs 9 to 12 person centred, consented, lawful care.',
    questions: [
      q('cd01', 'Care plans personalised, in the persons words, updated on change, reviewed to schedule.', 'responsive', 'Reg 9'),
      q('cd02', 'Risk assessments current for falls, pressure, nutrition, MCA, handling, skin with actions in care plan.', 'safe', 'Reg 12'),
      q('cd03', 'Consent recorded for care; where capacity lacking, best interest decisions documented.', 'safe', 'Reg 11', true),
      q('cd04', 'Deprivation of Liberty authorisations in date, conditions met, reviews done, IMCA involved.', 'safe', 'MCA/DoLS', true),
      q('cd05', 'Restrictive practice recorded, justified, least restrictive, time limited, reviewed.', 'safe', 'Reg 12', true),
      q('cd06', 'Life story and communication needs documented including hearing aids and glasses.', 'responsive', 'Reg 9'),
      q('cd07', 'End of life wishes and ACP recorded where appropriate; DNACPR with discussion evidence.', 'effective'),
      q('cd08', 'Records legible, dated, signed; confidentiality maintained.', 'wellled', 'Reg 17'),
      q('cd09', 'Resident and relative involvement evidenced in review meeting notes.', 'responsive', 'Reg 9'),
      q('cd10', 'GP, DN, therapy input filed and actioned.', 'effective'),
    ],
  },
  {
    id: 'monthly-staff', name: 'Monthly Staffing, Training and Recruitment Audit', frequency: 'monthly',
    description: 'Regs 18 and 19 right people, right skills, right support.',
    questions: [
      q('st01', 'Mandatory training matrix meets targets for safeguarding, fire, meds, IPC, food hygiene.', 'wellled', 'Reg 18'),
      q('st02', 'Supervisions to policy frequency, signed and meaningful.', 'wellled', 'Reg 18'),
      q('st03', 'Appraisals annual and completed.', 'wellled'),
      q('st04', 'Staff meetings monthly, minuted, actions followed.', 'wellled'),
      q('st05', 'Recruitment file sample: references, ID, DBS update service, right to work, induction.', 'safe', 'Reg 19', true),
      q('st06', 'Agency and bank staff inducted, trained, supervised; usage monitored.', 'safe', 'Reg 18'),
      q('st07', 'Spot quiz two staff on a residents care plan and safeguarding; answers correct.', 'effective'),
      q('st08', 'Staff say they feel supported; absence and turnover monitored and actioned.', 'wellled'),
      q('st09', 'Rota shows safe numbers and skill mix; contingency plan exists.', 'safe', 'Reg 18', true),
      q('st10', 'Values based recruitment evidenced in interview notes.', 'wellled'),
    ],
  },
  {
    id: 'monthly-feedback', name: 'Monthly Complaints and Feedback Review', frequency: 'monthly',
    description: 'Reg 16 complaints and listening more widely.',
    questions: [
      q('fb01', 'Complaints logged; acknowledged and responded within policy timescales.', 'responsive', 'Reg 16', true),
      q('fb02', 'Upheld complaints have action plans; complainant follow up recorded.', 'responsive', 'Reg 16'),
      q('fb03', 'Trends analysed and changes made as a result, closed loop and minuted.', 'wellled', 'Reg 17'),
      q('fb04', 'Compliments recorded and shared with the team.', 'wellled'),
      q('fb05', 'Resident and relative meetings held; minutes show real influence.', 'responsive'),
      q('fb06', 'Annual surveys for residents, relatives, staff done and actioned.', 'wellled'),
      q('fb07', 'Complaints policy accessible in easy read to residents and families.', 'responsive', 'Reg 16'),
      q('fb08', 'Online reviews monitored and responded to.', 'responsive'),
    ],
  },
  {
    id: 'monthly-governance', name: 'Monthly Governance and Well-led Review', frequency: 'monthly',
    description: 'Reg 17 and 20 the Outstanding differentiator: closed loop quality.',
    questions: [
      q('gv01', 'Audit schedule exists and this months audits completed on time.', 'wellled', 'Reg 17', true),
      q('gv02', 'Action plans from audits, complaints, incidents closed with verification, not just done.', 'wellled', 'Reg 17', true),
      q('gv03', 'Policies reviewed to schedule every three years; staff can find and describe key policies.', 'wellled', 'Reg 17'),
      q('gv04', 'CQC statutory notifications submitted in time for deaths, injuries, safeguarding.', 'wellled', 'Reg 18(2)', true),
      q('gv05', 'Duty of Candour evidenced: open discussion, written apology, records.', 'wellled', 'Reg 20', true),
      q('gv06', 'Vision and values visible and staff can state them; culture matches.', 'wellled'),
      q('gv07', 'Registration conditions complied with; statement of purpose accurate.', 'wellled'),
      q('gv08', 'Staff feel able to raise concerns; whistleblowing policy known.', 'wellled'),
      q('gv09', 'Incident trends for falls, meds, infection analysed monthly with actions.', 'wellled', 'Reg 17'),
      q('gv10', 'Equality and accessible info: reasonable adjustments recorded for residents.', 'responsive'),
    ],
  },
  {
    id: 'monthly-dols', name: 'Monthly MCA and DoLS Register Review', frequency: 'monthly',
    description: 'Mental Capacity Act and Deprivation of Liberty Safeguards.',
    questions: [
      q('dl01', 'Register of residents lacking capacity per specific decision; capacity assessments time specific.', 'safe', 'MCA', true),
      q('dl02', 'Best interest decisions documented with family and IMCA consultation.', 'safe', 'MCA', true),
      q('dl03', 'DoLS authorisations applied for in time; copies held; conditions complied with.', 'safe', 'DOLS', true),
      q('dl04', 'Every restraint episode recorded, justified, least restrictive, reviewed.', 'safe', 'Reg 12', true),
      q('dl05', 'RPR and IMCA engaged where required.', 'safe', 'MCA'),
      q('dl06', 'Staff can state the five MCA principles in plain language.', 'wellled'),
      q('dl07', 'No blanket restrictions like locked doors or bed rails without individual assessment.', 'safe', 'MCA', true),
      q('dl08', 'Authorisation care plans reviewed when needs change.', 'safe'),
    ],
  },
];